import { useLocation } from 'react-router-dom'
import { isMobile } from 'react-device-detect'
import { isEditorRoute } from 'src/pages/course-detail/tabs'

// Editors use their own full-width toolbar and open without the shell:
// - the course editor (/mini-course/:id/page|completion|.../editor)
// - landing page editors (/collection/:id/landing-page/editor,
//   /mini-course/:id/landing-page/editor), whose last segment is `editor`
//   (main/index.js also hides the top bar for that segment).
const isFullScreenEditor = pathname => {
  const segments = pathname.replace(/\/+$/, '').split('/')
  const [, root, , page, subPage] = segments
  if (root === 'mini-course' && isEditorRoute(page, subPage)) return true
  return segments[segments.length - 1] === 'editor'
}

/**
 * The side nav replaces the top tabs on desktop. Mobile keeps the top tabs.
 */
const useSideNavVisible = () => {
  const { pathname } = useLocation()
  return !isMobile && !isFullScreenEditor(pathname)
}

export default useSideNavVisible
